import React from 'react';
import { Link } from 'react-router-dom';

const BentoGrid = () => {
  return (
    <section className="section bento-section bg-subtle">
      <div className="container">
        <div className="section-header text-center mb-10 animate-on-scroll fade-up">
          <h2 className="h2">Entra nel mondo GD</h2>
          <p className="subtitle" style={{ marginInline: 'auto', maxWidth: 500 }}>
            Siamo radicati in ogni territorio. Trova la tua dimensione e unisciti alla nostra comunità.
          </p>
        </div>
        <div className="bento-grid">
          <Link to="/circoli" className="bento-item bento-item--large bento-hover animate-on-scroll fade-up">
            <div className="bento-content">
              <h3>20 Regioni, 850 Circoli</h3>
              <p>Trova la tua casa politica vicino a te.</p>
              <div className="btn btn--white btn--sm mt-4" style={{ color: 'var(--color-primary)' }}>Trova Circolo</div>
            </div>
            <div className="bento-bg" style={{ 
              backgroundImage: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.7)), url(https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?q=80&w=1200&auto=format&fit=crop)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}></div>
          </Link>
          <Link to="/notizie" className="bento-item bento-hover animate-on-scroll fade-up delay-100">
            <div className="bento-content">
              <h3>Notizie</h3>
              <p>Aggiornamenti quotidiani</p>
              <div className="btn btn--outline btn--sm mt-4" style={{ color: '#fff', borderColor: '#fff' }}>Leggi tutto</div>
            </div>
            <div className="bento-bg" style={{ 
              backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.8)), url(https://images.unsplash.com/photo-1504711434969-e33886168f5c?q=80&w=800&auto=format&fit=crop)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}></div>
          </Link>
          <Link to="/eventi" className="bento-item bento-hover animate-on-scroll fade-up delay-200">
            <div className="bento-content">
              <h3>Eventi</h3>
              <p>Partecipa dal vivo</p>
              <div className="btn btn--outline btn--sm mt-4" style={{ color: '#fff', borderColor: '#fff' }}>Scopri appuntamenti</div>
            </div>
            <div className="bento-bg" style={{ 
              backgroundImage: 'linear-gradient(rgba(122,31,28,0.4), rgba(122,31,28,0.9)), url(https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=800&auto=format&fit=crop)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}></div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BentoGrid;
